<dx-popup #popup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
    [showCloseButton]="true" title="Änderungsdetails" width="1300" height="520">
    <div *dxTemplate="let data of 'content'">
        <dx-data-grid class="changehistory-datagrid" [dataSource]="dataSource" [columnAutoWidth]="false"
            [width]="'100%'" [showColumnLines]="true" [showRowLines]="true" [showBorders]="true"
            [rowAlternationEnabled]="true" [allowColumnResizing]="true" [wordWrapEnabled]="true"
            columnResizingMode="widget" height="360px">
            <dxo-scrolling mode="standard" direction="both"></dxo-scrolling>

            <dxi-column alignment="left" dataField="entityName" caption="Entity" [width]="180"></dxi-column>
            <dxi-column alignment="left" dataField="entityKeyDisplay" caption="Entity-Id" [width]="150"></dxi-column>
            <!-- <dxi-column alignment="left" dataField="entityKeyDisplay" caption="Schlüssel" [width]="260"></dxi-column> -->
            <dxi-column alignment="left" dataField="changeTypeDisplay" caption="Aktion" [width]="110"></dxi-column>
            <dxi-column alignment="left" dataField="geaendertAm" caption="Änderungszeitpunkt" dataType="date"
                format="shortDateShortTime" [width]="170"></dxi-column>
            <dxi-column alignment="left" dataField="geaendertVon" caption="Benutzer" [width]="170"></dxi-column>
            <dxi-column alignment="left" dataField="details" caption="Details" [minWidth]="360"></dxi-column>
        </dx-data-grid>
    </div>
    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ text: 'Schließen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onClickClose }">
    </dxi-popup-toolbar-item>
</dx-popup>
